const validate = (values) => {
  const errors = {};

  if (!values.OrganizationName) {
    errors.OrganizationName = 'Please enter agency name';
  }

  if (!values.BusinessName) {
    errors.BusinessName = 'Please enter business name';
  }

  if (!values.Address1) {
    errors.Address1 = 'Please enter address';
  }

  if (!values.City) {
    errors.City = 'Please enter city';
  }

  if (!values.StateID || !Number.isInteger(values.StateID)) {
    errors.StateID = 'Please select state';
  }
  if (!values.CountryID || !Number.isInteger(values.CountryID)) {
    errors.CountryID = 'Please select country';
  }
  if (!values.Zip) {
    errors.Zip = 'Please enter zip code';
  }
  if (values.Zip) {

    if (values.Zip.length < 5) {

      errors.Zip = 'Please enter correct zip code';
    }
  }
  if (!values.Phone) {
    errors.Phone = 'Please enter phone number';
  }
  if (values.Phone) {

    if (values.Phone.length < 14) {

      errors.Phone = 'Please enter valid phone number';
    }
  }
  if (values.Fax) {
    if (values.Fax.length < 14) {
      errors.Fax = 'Please enter correct fax number';
    }
  }

  if (!values.Email) {
    errors.Email = 'Please enter email address';
  } else if (values.Email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,15}$/i.test(values.Email)) {
    errors.Email = 'Please enter valid email address';
  }
  if (!values.Fax) {
    errors.Fax = 'Please enter fax number';
  }

  // if (!values.ContactPersonTitle || !Number.isInteger(values.ContactPersonTitle)) {
  //   errors.ContactPersonTitle = 'Please select title for contact person';
  // }
  if (!values.ContactPersonFirstName) {
    errors.ContactPersonFirstName = 'Please enter contact person first name';
  }

  if (!values.ContactPersonLastName) {
    errors.ContactPersonLastName = 'Please enter contact person last name';
  }
  if (!values.ContactPersonPhoneNumber) {
    errors.ContactPersonPhoneNumber = 'Please enter contact person phone number';
  }
  if (values.ContactPersonPhoneNumber && values.ContactPersonPhoneNumber.length < 14) {
    errors.ContactPersonPhoneNumber = 'Please enter valid contact person phone number';
  }


  if (!values.UserName || values.UserName.trim() === '') {
    errors.UserName = 'Please enter user name';
  }
  if (values.UserName) {
    if (values.UserName.trim().length < 5) {
      errors.UserName = 'Please enter minimum 5 characters';
    }
  }

  // if (!values.Password || values.Password.trim() === '') {
  //   errors.Password = 'Please enter password';
  // }
  // if (values.Password) {
  //   if (values.Password.trim().length < 8) {
  //     errors.Password = 'Please enter minimum 8 characters';
  //   }
  // }

  if (!values.Password || values.Password.trim() === '') {
    errors.Password = 'Please enter password';
  } else if (!/^(?=.{8,30}$)/.test(values.Password)) {
    errors.Password = 'Password should contain minimum 8 and maximum 30 characters';
  } else {
    let pError = [], prefix = '';
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\+\-\_\@\#\$\%\&\!\,\[\]\{\}\(\)\|])/.test(values.Password)) {
      prefix = 'Password should contain atleast ';
    }
    if (!/^(?=.*[a-z])/.test(values.Password)) {
      pError.push('1 lowercase character');
    }
    if (!/^(?=.*[A-Z])/.test(values.Password)) {
      pError.push('1 uppercase character');
    }
    if (!/^(?=.*[0-9])/.test(values.Password)) {
      pError.push('1 numeric value');
    }
    if (!/^(?=.*[\+\-\_\@\#\$\%\&\!\,\[\]\{\}\(\)\|])/.test(values.Password)) {
      pError.push('1 special character');
    }
    errors.Password = prefix + pError.join(', ');
  }


  if (!values.ConfirmPassword || values.ConfirmPassword.trim() === '') {
    errors.ConfirmPassword = 'Please enter confirm password';
  }
  if (values.ConfirmPassword && values.Password && values.ConfirmPassword !== values.Password) {
    errors.ConfirmPassword = 'Password doesn\'t match';
  }

  if (!values.PayrollStartWeekDay) {
    errors.PayrollStartWeekDay = 'Please select start week day';
  }

  if (!values.PayrollEndWeekDay) {
    errors.PayrollEndWeekDay = 'Please select end week day';
  }

  if (values.PayrollStartWeekDay && values.PayrollStartWeekDay && values.PayrollStartWeekDay === values.PayrollEndWeekDay ) {
    errors.PayrollEndWeekDay = 'Start week day and End week day can not be same';
  }


  if (!values.PlanName) {
    errors.PlanName = 'Please enter subscription plan name';
  }

  if (!values.StartDate) {
    errors.StartDate = 'Please select subscription start date';
  }
  if (!values.PlanType || !Number.isInteger(values.PlanType)) {
    errors.PlanType = 'Please select subscription plan type';
  }
  if (!values.AmountPerClient) {
    errors.AmountPerClient = 'Please enter amount per client';
  }

  if (!values.TotalNumberOfClients) {
    errors.TotalNumberOfClients = 'Please enter total number of Clients';
  }


  if (!values.ServerName) {
    errors.ServerName = 'Please enter server name';
  }

  if (!values.Port) {
    errors.Port = 'Please enter port number';
  }

  if (!values.DatabaseDetailId && !Number.isInteger(values.DatabaseDetailId)) {
    errors.DatabaseDetailId = 'Please select database name';
  }

  if (!values.ConnectionSecurity) {
    errors.ConnectionSecurity = 'Please enter connection security';
  }
  if (!values.ServerName) {
    errors.ServerName = 'Please enter server name';
  }
  if (!values.Port) {
    errors.Port = 'Please enter port number';
  }

  if (!values.SMTPUserName || values.SMTPUserName.trim() === '') {
    errors.SMTPUserName = 'Please enter smtp user name';
  }
  if (values.SMTPUserName && values.SMTPUserName.trim().length < 5) {
    errors.SMTPUserName = 'Please enter minimum 5 characters';
  }

  if (!values.SMTPPassword || values.SMTPPassword.trim() === '') {
    errors.SMTPPassword = 'Please enter password';
  }
  if (values.SMTPPassword && values.SMTPPassword.trim().length < 8) {
    errors.SMTPPassword = 'Please enter minimum 8 characters';
  }
  if (!values.SMTPConfirmPassword || values.SMTPConfirmPassword.trim() === '') {
    errors.SMTPConfirmPassword = 'Please enter confirm password';
  }
  if (values.SMTPConfirmPassword && values.SMTPPassword && values.SMTPConfirmPassword !== values.SMTPPassword) {
    errors.SMTPConfirmPassword = 'Password doesn\'t match';
  }


  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/ManageAgency/components/validate.js